module.exports = __webpack_public_path__ + "static/logo_simple-377ce7cdba8c5a8029fc83218164b61f.svg";